import type { SVGProps } from "react";
import * as React from "react";
const SvgCanva = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#Canva_svg__a)">
      <circle cx={12} cy={12} r={11} fill="url(#Canva_svg__b)" />
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.115}
        d="M11.416 19.072a5.46 5.46 0 0 1-1.867-.434A5.565 5.565 0 0 1 9 18.356a4.89 4.89 0 0 1-1.521-1.468 3.805 3.805 0 0 1-.18-.287c-.324-.56-.547-1.158-.701-1.88a7.347 7.347 0 0 1-.16-1.508 9.098 9.098 0 0 1 .304-2.615c.131-.502.407-1.254.553-1.508.015-.025.072-.134.128-.24.29-.56.61-1.043.992-1.497a7.11 7.11 0 0 1 2.93-2.07c.124-.056.584-.189.805-.234.481-.098.793-.13 1.271-.13.425 0 .69.023 1.04.088.833.154 1.516.505 1.952 1.005a2.356 2.356 0 0 1 .451.773l.03.097.029.115c.01.047.023.107.03.132.032.141.044.525.021.741a3.596 3.596 0 0 1-.114.566c-.041.157-.11.318-.258.608-.027.054-.164.26-.232.35a3.452 3.452 0 0 1-.418.417 1.654 1.654 0 0 1-.298.201c-.28.149-.543.217-.787.204-.18-.01-.264-.048-.312-.144a.334.334 0 0 1-.031-.225c.02-.133.052-.216.214-.535.314-.619.42-.95.468-1.466a2.296 2.296 0 0 0-.093-.919 2.034 2.034 0 0 0-.208-.4 1.63 1.63 0 0 0-.324-.325 1.686 1.686 0 0 0-.538-.237 1.353 1.353 0 0 0-.298-.052 11.54 11.54 0 0 1-.16-.011 3.285 3.285 0 0 0-1.434.325 4.16 4.16 0 0 0-1.06.691c-.162.14-.418.396-.53.53-.378.46-.65.872-.891 1.35a9.208 9.208 0 0 0-.338.768 8.537 8.537 0 0 0-.44 1.645c-.155.79-.198 2-.098 2.758.02.155.08.505.097.574l.058.235c.08.327.22.707.37 1.01.19.385.413.697.698.98.233.232.386.354.619.494a3.348 3.348 0 0 0 .555.26c.265.1.572.152.945.16a3.903 3.903 0 0 0 1.453-.224l.138-.055c.543-.21 1.116-.587 1.583-1.04a7.252 7.252 0 0 0 .625-.7c.017-.02.063-.083.103-.14l.095-.131a14.653 14.653 0 0 0 .368-.591c.005-.006.05-.089.098-.184.124-.238.164-.3.216-.338.128-.092.289-.03.349.136.034.093.023.34-.022.524-.027.109-.137.424-.196.561a6.46 6.46 0 0 1-1.335 1.899c-.317.316-.619.563-.951.781l-.204.135c-.016.01-.071.042-.122.07a6.899 6.899 0 0 1-.607.298 5.085 5.085 0 0 1-2.311.389Z"
      />
    </g>
    <defs>
      <radialGradient
        id="Canva_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(51.743 .558 7.307) scale(21.713)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.356} stopColor="#02C1CC" />
        <stop offset={1} stopColor="#752AEC" />
      </radialGradient>
      <clipPath id="Canva_svg__a">
        <path fill="#fff" d="M1 1h22v22H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCanva;
